<template>
  <div :v-if="isInRole(['admin'])">
    <toolbar/>
    <zlick-navigation />
    <v-container fluid text-xs-center>
      <v-layout row wrap center justify-center>
        <v-flex xs12 sm6 md4>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-switch
                v-model="twoFAEnabled"
                :label="`Two-Factor Authentication (2FA) : ${twoFAEnabled ? 'ON' : 'OFF'}`"
                v-on="on">
              </v-switch>
            </template>
            <span>{{$t('toolTipTwoFA')}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-container>
     <v-container fluid text-xs-center>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-text>
            <v-flex xs12 offset-xs0>
              <h3>{{$t('delete')}}</h3>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">{{$t('cancel')}}</v-btn>
            <v-btn color="blue darken-1" flat @click.native="deleteItem">{{$t('confirm')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-container>
      <v-layout row wrap center>
        <v-flex xs12 offset-xs0>
          <v-form ref="addUser" lazy-validation>
            <v-text-field
              type="email"
              name="user_email"
              v-model="user_email"
              validate-on-blur
              :rules="[v => !!v || $t('email_required')]"
              :label="$t('user_email')"
              :placeholder="$t('placeholderemail')"
              required
            />
           <v-text-field
                  v-model="user_name"
                  :label="$t('user_name')"
                  :rules="[v => !!v || $t('name_required')]"
                  :placeholder="$t('placeholdername')"
                  required
                ></v-text-field>
          <v-select
                  v-model="roles"
                  :items="options"
                  :menu-props="{ maxHeight: '400' }"
                  label="Roles"
                  :rules="[v => !!v || $t('role_required')]"
                  :placeholder="$t('placeholderrole')"
                  multiple
                  chips
                  persistent-hint
                  required
                ></v-select>
            <v-btn @click="addUser">{{ $t('adduser') }}</v-btn>
            <v-btn @click="clear">{{ $t("clear") }}</v-btn>
            <br />
            <a href="https://developer.zlick.it/concepts/portal.html" target="_blank">Learn more about roles</a>
            <br />
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="!error" fluid text-xs-center>
    <v-layout row wrap center>
      <v-flex xs12 offset-xs0>
        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <td class=“text-xs-center” @click="editUser(props.item)"> <a>{{ formatUserInfo(props.item.Attributes, 'email' )}}</a></td>
            <td class=“text-xs-center”>{{ formatUserInfo(props.item.Attributes,'name' )}}</td>
            <td class="text-xs-center">{{ formatUserInfo(props.item.Attributes, 'role' )}}</td>
            <td class="text-xs-center">{{ formatStatus(props.item.UserStatus) }}</td>
            <td class="text-xs-center">{{ formatDate(props.item.UserCreateDate) }}</td>
            <td class="text-xs-center">{{ formatDate(props.item.UserLastModifiedDate) }}</td>
            <td class="text-xs-bottom">
              <v-btn icon class="mx-0" >
                <v-icon @click="showDeleteBox(props.item.Username, formatUserInfo(props.item.Attributes, 'email'))" color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>

          <template slot="no-data">
            <v-btn color="primary" @click="initialize">{{$t('reload')}}</v-btn>
          </template>
        </v-data-table>
      </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

import Toolbar from './Toolbar'
import ZlickNavigation from './ZlickNavigation'
import UserManagementService from '../services/UserManagementService'
import moment from 'moment'
import AuthenticationService from '../services/AuthenticationService'
import Raygun from '../services/Raygun'
import { mapState } from 'vuex'

export default {
  components: {
    Toolbar,
    ZlickNavigation
  },
  data: function () {
    return {
      dialog: false,
      email: '',
      user_email: '',
      options: ['admin', 'support', 'telemarketing', 'analyst'],
      ADMIN_EMAIL: ['jane.tedremaa@zlick.it', 'waqas.tahir@zlick.it', 'jaan.saks@zlick.it', 'aiman@zlick.it'],
      deleteEmail: '',
      roles: '',
      user_name: '',
      itemToBeDeleted: '',
      twoFAEnabled: '',
      headers: [
        {text: this.$t('email'), value: 'email', sortable: true, align: 'center'},
        {text: this.$t('user'), value: 'name', align: 'center'},
        {text: this.$t('roles'), value: 'role', align: 'center'},
        {text: this.$t('accountStatus'), value: 'UserStatus', align: 'center'},
        {text: this.$t('createdAt'), value: 'UserCreateDate', align: 'center'},
        {text: this.$t('updatedAt'), value: 'UserLastModifiedDate', align: 'center'}
      ],
      itemToDelete: ''
    }
  },
  mounted () {
    var apiClient = JSON.parse(localStorage.getItem('apiClient'))
    this.twoFAEnabled = apiClient.portalTwoFAEnabled
  },
  beforeCreate () {
    if (!AuthenticationService.isUserLoggedIn()) {
      this.$router.push('/login')
      return
    }
    if (!AuthenticationService.isInRole(['admin', 'support', 'analyst'])) {
      this.$router.push('/telemarketing')
    }
  },

  created () {
    this.initialize()
  },

  computed: {

    ...mapState({
      activeCognitoGroup: state => state.user.activeCognitoGroup
    }),

    items: {
      get: function () {
        return Object.values(this.$store.state.users)
      },
      set: function (newValue) {
        this.$store.commit('setUsers', newValue)
      }
    },
    pagination: {
      get: function () {
        return this.$store.state.pagination
      },
      set: function (newValue) {
        this.$store.commit('setPagination', newValue)
      }
    },
    error: {
      get: function () {
        return this.$store.state.error
      },
      set: function (newValue) {
        this.$store.commit('setError', newValue)
      }
    }
  },
  watch: {

    activeCognitoGroup (newValue, oldValue) {
      console.log(`cognito Updating from ${oldValue} to ${newValue}`)
      this.initialize()
    },
    twoFAEnabled: function (newVal, oldVal) {
      this.switchTwoFAStatus(newVal)
      let apiClient = JSON.parse(localStorage.getItem('apiClient'))
      apiClient.portalTwoFAEnabled = newVal
      localStorage.setItem('apiClient', JSON.stringify(apiClient))
    },

    pagination: {
      handler () {
        this.$store.dispatch('sortUsers')
      },
      deep: true
    }
  },

  methods: {
    async newPage (page) {
      let response = await UserManagementService.getAllUsersInGroup()
      this.$store.commit('setUsers', response.data)
    },
    objectIsEmpty (object) {
      return Object.keys(object).length === 0 && object.constructor === Object
    },
    isInRole (roles) {
      return AuthenticationService.isInRole(roles)
    },
    async initialize () {
      try {
        this.$store.commit('setError', null)
        let response = await UserManagementService.getAllUsersInGroup()
        this.$store.commit('setUsers', response.data)
      } catch (error) {
        this.$store.commit('setError', error.message)
        Raygun.send(error)
      }
    },

    editUser (item) {
      var email = this.formatUserInfo(item.Attributes, 'email')
      var roles = this.formatUserInfo(item.Attributes, 'role')
      localStorage.setItem('editUserEmail', email)
      localStorage.setItem('editUserRoles', roles)
      this.$router.push('/editUser')
      return '/editUser'
    },

    formatDate (createdAt) {
      return moment(createdAt).format('DD.MM.YYYY HH:mm:ss')
    },

    formatUserInfo (attributes, key) {
      for (const attribute of attributes) {
        if (attribute.Name === 'email' & key === 'email') {
          return attribute.Value.toString()
        }
        if (attribute.Name === 'name' & key === 'name') {
          return attribute.Value.toString()
        }
        if (attribute.Name === 'custom:role' & key === 'role') {
          let values = []
          values.push(attribute.Value.split(' '))
          return values.join(',  ')
        }
      }
    },

    formatStatus (status) {
      if (status !== 'CONFIRMED') {
        return 'Pending'
      }
      return 'Confirmed'
    },

    async switchTwoFAStatus (status) {
      await UserManagementService.updateApiClientTwoFA(status)
    },

    async deleteItem () {
      try {
        if (this.ADMIN_EMAIL.includes(this.deleteEmail)) {
          this.$toast.error(this.$t('deleteAdmin'))
          return
        }
        await UserManagementService.deleteUserInGroup(this.itemToBeDeleted)
        this.$toast.success('User successfully deleted')
        this.error = 'User is deleted!'
        this.initialize()
        return
      } catch (error) {
        this.$toast.error(error.message)
        Raygun.send(error)
      } finally {
        this.close()
      }
    },
    close () {
      this.dialog = false
    },

    showDeleteBox (item, email) {
      this.dialog = true
      this.itemToBeDeleted = item
      this.deleteEmail = email
    },

    clear () {
      this.user_email = ''
      this.user_name = ''
      this.roles = ''
      this.deleteEmail = ''
      this.itemToBeDeleted = ''
    },

    async addUser () {
      if (!this.$refs.addUser.validate()) return
      try {
        await UserManagementService.createUserAndAddToGroup(this.user_email, this.user_name, this.roles)
        this.$toast.success('Successfully done')
        this.clear()
        this.initialize()
        return
      } catch (error) {
        this.$toast.error(error.message)
        Raygun.send(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ManageUsers.vue